'use client';
import classNames from 'classnames';
import { useState } from 'react';

export default function ClientTitle({ prefixCls, title }: { prefixCls: string; title?: React.ReactNode }) {
    const [openA, setOpenA] = useState(false);
    const itemClasses = classNames({
        [`${prefixCls}-item-title`]: true,
        [`${prefixCls}-item-open`]: openA,
    });
    const toggleHandle = () => {
        const openA2 = !openA;
        setOpenA(openA2);
    };
    if (!title) {
        return null;
    }
    return (
        <p className={itemClasses} onClick={toggleHandle}>
            <span>{title}</span>
            <svg className={`${prefixCls}-title-icon`} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                    d="M13.5381 5.74381L8.20475 11.0771L2.87142 5.74382"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </p>
    );
}
